import React from "react";
import HeroBanner from "../components/HeroBanner";
import Features from "../components/Features";
import About from "../components/About";
import Contact from "../components/Contact";
import NewFooter from "../components/NewFooter";
import NewHowItWorks from "../components/NewHowItWorks";
import NewTestimonials from "../components/NewTestimonials";
import NewWhatsAppButton from "../components/NewWhatsAppButton";

const Home = () => {
  return (
    <div className="home">
      <HeroBanner />
      <Features />
      <NewHowItWorks />
      <About />
      <NewTestimonials />
      <Contact />
      <NewFooter />
      <NewWhatsAppButton />
    </div>
  );
};

export default Home;
